angular.module('bmsApp.file', []);
angular.module('bmsApp.file').factory('FileSvc', function ($http, $log, $window, $q) {

	return {
		delete: function (filepath) {
			var deferred = $q.defer();
			var config = {
				params: {
					filepath: filepath
				}
			};
			$http.get('api/file/delete', config)
				.then(function (response) {
					if (response.data.success) {
						deferred.resolve(response);
					}
					else {
						deferred.reject(response.data.errors);
					}
				}, function (error) {
					deferred.reject("A generic API error occured: " + error.data.error.message);
				});

			return deferred.promise;
		}
		
	};

});